var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"skeleton-wrapper"},[_c('div',{staticClass:"skeleton-item",style:({ width: _vm.width, height: _vm.height, 'border-radius': _vm.radius })})])
}
var staticRenderFns = []

export { render, staticRenderFns }